<template>
  <div id="content">
    <div class="inner">
      <h1 v-translate>Vlastní exporty</h1>
    </div>

    <div class="inner_white">
      <table class="vypis" ref="table_with_action_line" v-show="dataLoaded">
        <thead>
        <tr>
          <th class="no_padding drag_drop"></th>
          <th class="no_padding checkbox"></th>
          <sorting-table-title
              v-for="title in sortingTableTitles"
              :key="title.id"
              :column="title.column"
              :sort="getActiveSort(title.column)"
              @changeSorting="changeSorting"
          >{{ title.name }}
          </sorting-table-title>
        </tr>
        </thead>
        <tbody>
        <custom-export-row
            v-for="entity in entities"
            :entity="entity"
            :key="entity.id"
            :selectedEntities="selectedEntities"
            @input="select"
            :ref="'custom-export-row-ref-'+entity.id"
        ></custom-export-row>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import CustomExportRow from "@/components/views/customExports/CustomExportRow"
import listActions from "@/components/mixins/list-actions"

export default {
  name: "CustomExportsList",
  components: {CustomExportRow},
  mixins: [listActions],
  data() {
    return {
      moduleName: 'customExports',
      sortingTableTitles: [
        {id: 1, name: this.$gettext('Popis')},
        {id: 2, name: this.$gettext('Celkový počet běhů')},
        {id: 3, name: this.$gettext('Poslední spuštění')},
        {id: 4, name: this.$gettext('Vytvořeno')}
      ],
    }
  },
  created(CustomExportService) {
    this.entityService = CustomExportService
    this.createdInit()
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/customExports/CustomExportList.vue